module.exports = __webpack_public_path__ + "media/images/john-pear-sons copy-a2a316d1a74bdf7274e2e5d848cd1ae6.png";